var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',[_c('paginate',{attrs:{"page-count":_vm.totalPage,"click-handler":_vm.goToNextPage,"prev-text":'Prev',"next-text":'Next',"container-class":'pagination'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }